import React from 'react'
import {useHistory} from 'react-router-dom'
import {PageTitle} from '../../../_metronic/layout/core'
import {createProjectSelectionDetail, dispatchProjectSelectionChange} from '../projectdetails/constants'
import {useProjectSelection} from '../projectdetails/hooks/useProjectSelection'
import {singleProjectLandingRoute} from '../projectdetails/selectionMode'

const PortfolioAccessDenied: React.FC<{pageNames: string[]}> = ({pageNames}) => {
  const history = useHistory()
  const {projects} = useProjectSelection()
  const project = projects[0]

  return (
    <>
      <PageTitle breadcrumbs={[]}>Portfolio Overview</PageTitle>
      <section aria-labelledby='portfolio-access-title' className='py-6'>
        <h2 id='portfolio-access-title' className='fs-3 mb-3'>Portfolio Overview</h2>
        <p role='status' className='text-muted'>You do not have permission to view Portfolio Overview.</p>
        {project && <button type='button' className='btn btn-sm btn-light-primary text-wrap text-break text-start mw-100'
          onClick={() => {
            dispatchProjectSelectionChange(createProjectSelectionDetail([project]))
            history.replace(singleProjectLandingRoute(pageNames))
          }}>
          <i className='bi bi-folder2-open me-2' aria-hidden='true' />Open {project.projectName}
        </button>}
      </section>
    </>
  )
}

export default PortfolioAccessDenied
